import { Analytics } from '../analytics';

export const trackError = (errorStatusCode: any) => {
  const statusNumber = Number.isNaN(Number(errorStatusCode)) ? 500 : Number(errorStatusCode);

  const analyticsData: any = {
    401: {
      eventType: 'Login',
      eventAction: 'Unauthorized',
      errorMessage: 'Unauthorized',
    },
    403: {
      eventType: 'Access',
      eventAction: 'Denied',
      errorMessage: 'Access denied',
    },
    404: {
      eventType: 'Error',
      eventAction: 'Page not found',
      errorMessage: 'Page not found',
    },
    500: {
      eventType: 'Error',
      eventAction: 'Technical Error',
      errorMessage: 'Technical Error',
      pageName: 'Technical Error',
      viewChange: 'Technical Error',
    },
  };

  Analytics.push(analyticsData[statusNumber]);
};
